module.exports = __webpack_public_path__ + "static/media/chanpinbankuai_140.6a414406.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/chanpinbankuai_140.svg
// module id = 681
// module chunks = 0